var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var _a, _b, _c, _d;
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import dayjs from 'dayjs';
import { defaultCenterClasses, defaultInputClasses, defaultTextInputRootClasses, } from './text-input.config';
import { useObject } from '../../common/hooks';
import { Row, Col } from '../../components/Grid';
import { Label } from '../../components/Text';
import { KeyCodes } from '@gower/utils/src/global/KeyEnum';
import { BottomContent, LeftContent, RightContent, TopContent, } from './text-input.content';
import classNames from 'classnames';
var DateInputType;
(function (DateInputType) {
    DateInputType["DAY"] = "day";
    DateInputType["MONTH"] = "month";
    DateInputType["YEAR"] = "year";
})(DateInputType || (DateInputType = {}));
;
var Interactions = (_a = {},
    _a[KeyCodes.ArrowRight] = (_b = {},
        _b[DateInputType.DAY] = DateInputType.MONTH,
        _b[DateInputType.MONTH] = DateInputType.YEAR,
        _b),
    _a[KeyCodes.ArrowLeft] = (_c = {},
        _c[DateInputType.MONTH] = DateInputType.DAY,
        _c[DateInputType.YEAR] = DateInputType.MONTH,
        _c),
    _a);
var handlers = (_d = {},
    _d[DateInputType.DAY] = {
        validate: function (text) {
            var day = Number(text);
            if (text.length === 2 && day > 0 && day <= 31)
                return true;
        },
        format: function (text) {
            var day = Number(text);
            if (day > 0 && day <= 31)
                return text.padStart(2, '0');
            return false;
        }
    },
    _d[DateInputType.MONTH] = {
        validate: function (text) {
            var month = Number(text);
            if (text.length === 2 && month > 0 && month <= 12)
                return true;
        },
        format: function (text) {
            var month = Number(text);
            if (month > 0 && month <= 12)
                return text.padStart(2, '0');
            return false;
        }
    },
    _d[DateInputType.YEAR] = {
        validate: function (text) {
            var year = Number(text);
            if (text.length === 4 && year > 1000)
                return true;
        },
        format: function (text) {
            var year = Number(text);
            if (text && text.length <= 2) {
                if (year < 30)
                    return '2' + text.padStart(3, '0');
                else
                    return '19' + text.padStart(2, '0');
            }
            else if (text.length <= 3) {
                return '2' + text.padStart(3, '0');
            }
            else if (year > 1000) {
                return text;
            }
            return false;
        }
    },
    _d);
export var TextDateInput = React.forwardRef(function (_a, ref) {
    var _b, _c;
    var initialValue = _a.initialValue, value = _a.value, onChange = _a.onChange, onClear = _a.onClear, onChangeDate = _a.onChangeDate, _d = _a.selectAllOnFocus, selectAllOnFocus = _d === void 0 ? true : _d, _e = _a.clearable, clearable = _e === void 0 ? false : _e, onChangeMode = _a.onChangeMode, _f = _a.mode, mode = _f === void 0 ? 'onEnter' : _f, onKeyUp = _a.onKeyUp, onKeyDown = _a.onKeyDown, onEnterUp = _a.onEnterUp, onEnterDown = _a.onEnterDown, onEscapeUp = _a.onEscapeUp, onEscapeDown = _a.onEscapeDown, 
    //delayed,
    //noDelayed,
    //delayedTime = 300,
    _g = _a.className, 
    //delayed,
    //noDelayed,
    //delayedTime = 300,
    className = _g === void 0 ? '' : _g, _h = _a.variant, variant = _h === void 0 ? 'outlined' : _h, _j = _a.inputSize, inputSize = _j === void 0 ? 'normal' : _j, filled = _a.filled, outlined = _a.outlined, solo = _a.solo, borderless = _a.borderless, border = _a.border, small = _a.small, normal = _a.normal, large = _a.large, _k = _a.rounded, rounded = _k === void 0 ? false : _k, _l = _a.errored, errored = _l === void 0 ? false : _l, suffix = _a.suffix, prefix = _a.prefix, label = _a.label, hint = _a.hint, error = _a.error, contentLeft = _a.contentLeft, contentRight = _a.contentRight, contentTop = _a.contentTop, contentBottom = _a.contentBottom, preventClickLeftContent = _a.preventClickLeftContent, preventClickRightContent = _a.preventClickRightContent, labelProps = _a.labelProps, hintProps = _a.hintProps, suffixProps = _a.suffixProps, prefixProps = _a.prefixProps, errorProps = _a.errorProps, clearableOnEscape = _a.clearableOnEscape, clearableProps = _a.clearableProps, onFocus = _a.onFocus, onBlur = _a.onBlur, readOnly = _a.readOnly, disabled = _a.disabled, loading = _a.loading, required = _a.required, minLength = _a.minLength, validate = _a.validate, errorTime = _a.errorTime, onValidateError = _a.onValidateError, requiredLength = _a.requiredLength, showCounter = _a.showCounter, noFocuseable = _a.noFocuseable, props = __rest(_a, ["initialValue", "value", "onChange", "onClear", "onChangeDate", "selectAllOnFocus", "clearable", "onChangeMode", "mode", "onKeyUp", "onKeyDown", "onEnterUp", "onEnterDown", "onEscapeUp", "onEscapeDown", "className", "variant", "inputSize", "filled", "outlined", "solo", "borderless", "border", "small", "normal", "large", "rounded", "errored", "suffix", "prefix", "label", "hint", "error", "contentLeft", "contentRight", "contentTop", "contentBottom", "preventClickLeftContent", "preventClickRightContent", "labelProps", "hintProps", "suffixProps", "prefixProps", "errorProps", "clearableOnEscape", "clearableProps", "onFocus", "onBlur", "readOnly", "disabled", "loading", "required", "minLength", "validate", "errorTime", "onValidateError", "requiredLength", "showCounter", "noFocuseable"]);
    if (!props.autoComplete)
        props.autoComplete = "nope";
    if (!props["aria-autocomplete"])
        props["aria-autocomplete"] = "none";
    if (!props.autoCorrect)
        props.autoCorrect = "off";
    //if ( delayed ) onChangeMode = 'delayed';
    //if ( noDelayed ) onChangeMode = 'normal';
    if (filled)
        variant = 'filled';
    else if (solo)
        variant = 'solo';
    else if (borderless)
        variant = 'borderless';
    else if (border)
        variant = 'border';
    else if (outlined)
        variant = 'outlined';
    if (small)
        inputSize = 'small';
    else if (large)
        inputSize = 'large';
    else if (normal)
        inputSize = 'normal';
    var _m = React.useState(null), internalValue = _m[0], setInternalValue = _m[1];
    var _o = React.useState(''), internalError = _o[0], setInternalError = _o[1];
    var dateComponents = useObject({
        day: '',
        month: '',
        year: '',
    });
    var inputDayRef = React.useRef(null);
    var inputMonthRef = React.useRef(null);
    var inputYearRef = React.useRef(null);
    var inputRefs = (_b = {},
        _b[DateInputType.DAY] = inputDayRef,
        _b[DateInputType.MONTH] = inputMonthRef,
        _b[DateInputType.YEAR] = inputYearRef,
        _b);
    var filledValue = Boolean(internalValue);
    React.useEffect(function () {
        var date = dayjs(value || null);
        if (!date.isSame(internalValue)) {
            setInternalValue(date);
            if (date === null || date === void 0 ? void 0 : date.isValid()) {
                dateComponents.day = date === null || date === void 0 ? void 0 : date.format('DD');
                dateComponents.month = date === null || date === void 0 ? void 0 : date.format('MM');
                dateComponents.year = date === null || date === void 0 ? void 0 : date.format('YYYY');
            }
            else {
                dateComponents.day = '';
                dateComponents.month = '';
                dateComponents.year = '';
            }
        }
    }, [value]);
    function getDate() {
        var day = dateComponents.day, month = dateComponents.month, year = dateComponents.year;
        if (day && month && year) {
            var date = dayjs(new Date(Number(year), Number(month) - 1, Number(day)));
            if (date.isValid())
                return date;
        }
        return null;
    }
    function commitOnChange(event, emit) {
        var date = getDate();
        event.target['value'] = date;
        onChange && onChange(event);
        if (emit)
            onChangeDate && onChangeDate(date);
    }
    function commitOnEnter(type, event) {
        var formated = handlers[type].format(dateComponents[type]);
        if (formated != false) {
            dateComponents[type] = formated;
        }
        commitOnChange(event, true);
    }
    function commitOnBlur(type, event) {
        var formated = handlers[type].format(dateComponents[type]);
        if (formated != false) {
            dateComponents[type] = formated;
        }
        commitOnChange(event, true);
    }
    function onInternalChange(type, event) {
        var _a, _b;
        dateComponents[type] = event.target.value;
        var validated = handlers[type].validate(event.target.value);
        if (validated) {
            var typeInteraction = Interactions[KeyCodes.ArrowRight][type];
            if (typeInteraction) {
                (_b = (_a = inputRefs[typeInteraction]) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.focus();
            }
        }
        commitOnChange(event, mode === 'onChange');
    }
    function onInternalKeyUp(type, event) {
        var _a, _b;
        var keyInteraction = Interactions[event.key];
        if (keyInteraction) {
            var typeInteraction = keyInteraction[type];
            if (typeInteraction) {
                (_b = (_a = inputRefs[typeInteraction]) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.focus();
            }
        }
        else if (event.key == KeyCodes.Enter) {
            commitOnEnter(type, event);
            onEnterUp && onEnterUp(event);
        }
        else if (event.key == KeyCodes.Escape) {
            onEscapeUp && onEscapeUp(event);
        }
        onKeyUp && onKeyUp(event);
    }
    function onInternalKeyDown(type, event) {
        if (event.key == KeyCodes.Enter) {
            onEnterDown && onEnterDown(event);
        }
        else if (event.key == KeyCodes.Escape) {
            onEscapeDown && onEscapeDown(event);
        }
        onKeyDown && onKeyDown(event);
    }
    function onInternalBlur(type, event) {
        commitOnBlur(type, event);
        onBlur && onBlur(event);
    }
    function onInternalFocus(type, event) {
        var _a;
        if (selectAllOnFocus)
            (_a = event.currentTarget) === null || _a === void 0 ? void 0 : _a.select();
        onFocus && onFocus(event);
    }
    function internalOnClear(event) {
        var _a, _b;
        //event.target.value = '';
        //internalOnChange( event );
        (_b = (_a = inputRefs['day']) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.focus();
        onClear && onClear(event);
    }
    var style = {
        outline: 'none',
        border: 'none',
        background: 'transparent',
    };
    function rootOnClick(event) {
        var _a, _b, _c;
        if (event.target.tagName.toLowerCase() === 'input')
            (_a = event.target) === null || _a === void 0 ? void 0 : _a.focus();
        else
            (_c = (_b = inputRefs['day']) === null || _b === void 0 ? void 0 : _b.current) === null || _c === void 0 ? void 0 : _c.focus();
    }
    var rootClasses = classNames(defaultTextInputRootClasses, (_c = {
            '__text_date_input': true,
            '__rounded': rounded
        },
        _c["__input_size_".concat(inputSize)] = true,
        _c["__input_variant_".concat(variant)] = true,
        _c), className);
    var centerClasses = classNames(defaultCenterClasses, {
        '__rounded': rounded,
        '__errored': errored || Boolean(internalError),
    }, className);
    return _jsx(_Fragment, { children: _jsxs("div", __assign({ className: rootClasses, style: style, onClick: rootOnClick }, { children: [_jsx(TopContent, { disabled: disabled || readOnly, label: label, size: inputSize, variant: variant, labelProps: labelProps, contentTop: contentTop }), _jsxs("div", __assign({ className: centerClasses }, { children: [_jsx(LeftContent, { prefix: prefix, size: inputSize, prefixProps: prefixProps, contentLeft: contentLeft, preventClickLeftContent: preventClickLeftContent }), _jsxs("div", __assign({ className: defaultInputClasses }, { children: [_jsx("div", __assign({ className: "__input_date_component day" }, { children: _jsx("input", __assign({}, props, { style: style, ref: inputDayRef, maxLength: 2, value: dateComponents.day, onFocus: function (event) { return onInternalFocus(DateInputType.DAY, event); }, onBlur: function (event) { return onInternalBlur(DateInputType.DAY, event); }, onKeyUp: function (event) { return onInternalKeyUp(DateInputType.DAY, event); }, onKeyDown: function (event) { return onInternalKeyDown(DateInputType.DAY, event); }, onChange: function (event) { return onInternalChange(DateInputType.DAY, event); } })) })), _jsx("div", __assign({ className: "__input_date_component separator" }, { children: "/" })), _jsx("div", __assign({ className: "__input_date_component month" }, { children: _jsx("input", __assign({}, props, { style: style, ref: inputMonthRef, maxLength: 2, value: dateComponents.month, onFocus: function (event) { return onInternalFocus(DateInputType.MONTH, event); }, onBlur: function (event) { return onInternalBlur(DateInputType.MONTH, event); }, onKeyUp: function (event) { return onInternalKeyUp(DateInputType.MONTH, event); }, onKeyDown: function (event) { return onInternalKeyDown(DateInputType.MONTH, event); }, onChange: function (event) { return onInternalChange(DateInputType.MONTH, event); } })) })), _jsx("div", __assign({ className: "__input_date_component separator" }, { children: "/" })), _jsx("div", __assign({ className: "__input_date_component year" }, { children: _jsx("input", __assign({}, props, { style: style, ref: inputYearRef, maxLength: 4, value: dateComponents.year, onFocus: function (event) { return onInternalFocus(DateInputType.YEAR, event); }, onBlur: function (event) { return onInternalBlur(DateInputType.YEAR, event); }, onKeyUp: function (event) { return onInternalKeyUp(DateInputType.YEAR, event); }, onKeyDown: function (event) { return onInternalKeyDown(DateInputType.YEAR, event); }, onChange: function (event) { return onInternalChange(DateInputType.YEAR, event); } })) }))] })), _jsx(RightContent, { password: false, loading: loading, disabled: disabled || readOnly, filled: filledValue, suffix: suffix, size: inputSize, variant: variant, suffixProps: suffixProps, contentRight: contentRight, clearable: clearable, onClear: internalOnClear, clearableProps: clearableProps, isPasswordVisible: null, tooglePasswordVisibility: null, passwordButtonProps: null, preventClickRightContent: preventClickRightContent })] })), _jsx(BottomContent, { currentLength: null, maxLength: null, requiredLength: null, showCounter: null, hint: hint, error: internalError, size: inputSize, hintProps: hintProps, errorProps: errorProps, contentBottom: contentBottom })] })) });
    return _jsx(_Fragment, { children: _jsxs(Row, __assign({ rows: true, justifyStart: true }, { children: [_jsx(Col, __assign({ gutter: true, center: true, width: 20 }, { children: _jsx("input", __assign({}, props, { style: style, ref: inputDayRef, maxLength: 2, value: dateComponents.day, onFocus: function (event) { return onInternalFocus(DateInputType.DAY, event); }, onBlur: function (event) { return onInternalBlur(DateInputType.DAY, event); }, onKeyUp: function (event) { return onInternalKeyUp(DateInputType.DAY, event); }, onKeyDown: function (event) { return onInternalKeyDown(DateInputType.DAY, event); }, onChange: function (event) { return onInternalChange(DateInputType.DAY, event); } })) })), _jsx(Col, __assign({ gutter: true, center: true }, { children: _jsx(Label, { label: "/" }) })), _jsx(Col, __assign({ gutter: true, center: true, width: 20 }, { children: _jsx("input", __assign({}, props, { style: style, ref: inputMonthRef, maxLength: 2, value: dateComponents.month, onFocus: function (event) { return onInternalFocus(DateInputType.MONTH, event); }, onBlur: function (event) { return onInternalBlur(DateInputType.MONTH, event); }, onKeyUp: function (event) { return onInternalKeyUp(DateInputType.MONTH, event); }, onKeyDown: function (event) { return onInternalKeyDown(DateInputType.MONTH, event); }, onChange: function (event) { return onInternalChange(DateInputType.MONTH, event); } })) })), _jsx(Col, __assign({ gutter: true, center: true }, { children: _jsx(Label, { label: "/" }) })), _jsx(Col, __assign({ gutter: true, center: true, width: 50 }, { children: _jsx("input", __assign({}, props, { style: style, ref: inputYearRef, maxLength: 4, value: dateComponents.year, onFocus: function (event) { return onInternalFocus(DateInputType.YEAR, event); }, onBlur: function (event) { return onInternalBlur(DateInputType.YEAR, event); }, onKeyUp: function (event) { return onInternalKeyUp(DateInputType.YEAR, event); }, onKeyDown: function (event) { return onInternalKeyDown(DateInputType.YEAR, event); }, onChange: function (event) { return onInternalChange(DateInputType.YEAR, event); } })) }))] })) });
});
